import { Col, Flex, notification, Row, Space } from "antd";
import React from "react";
import LocationsApi from "../../api-services/locations-api.service";
import { Country } from "../../interfaces/country.interface";


interface IMainFooterProps {
  PDPA:string;
  PRIVACY:string;
  TNC:string;
}

export default class MainFooter extends React.Component<IMainFooterProps> {
  api = new LocationsApi;

  state = {
    countries: []
  }

  menus = [
    {
      label: "Home",
      link: "/web"
    },
    {
      label: "pdpa",
      link: this.props.PDPA,
      target: "_blank"
    },
    {
      label: "about us",
      link: "/web/about-us"
    },
    {
      label: "privacy policy",
      link: this.props.PRIVACY,
      target: "_blank"
    },
    {
      label: "contact us",
      link: "/web/contact-us"
    },
    {
      label: "terms & conditions",
      link: this.props.TNC,
      target: "_blank"
    },
  ]

  componentDidMount() {
    this.api.getCountries()
      .then(locationsData => {
        this.setState({countries: locationsData})
      })
      .catch(error => {
        notification.error({ message: 'An error occured while loading countries.'});
      });
  }
  
  render(){
    return (
      <div id="main-footer">
        <Row id="main-footer_links" gutter={[12, 12]}>
          <Col id="countries" className="column">
            <Space direction="vertical">
              <div className="link-group-title">Countries</div>
              <div className="link-group-items">
                {
                  this.state.countries.map((country: Country)=> <a key={country.id} href={`/web/listing?location_id=${country.id}`} target="_self"> {country.name} </a> )
                }
              </div>
            </Space>
          </Col>
          <Col id="footer-menus" className="column footer-menu">
            <Space direction="vertical">
              <div className="link-group-items">
                {
                  this.menus.map((menu, index) =><a key={index} target={menu.target} href={menu.link}> {menu.label} </a>)
                }
              </div>
            </Space>
          </Col>
          <Col id="contact-infos" className="column contact-info">
            <Space direction="vertical" align="center">
              <Flex vertical gap="20px" align="center">
                <div className="link-group-title">Contact Us</div>
                <div><a href="/web/contact-agents">contact agents</a></div>
                <div className="link-group-title">Follow us on</div>
                <Flex gap={20} justify="space-between" className="social-icons">  
                  <a target="_blank" href="https://www.facebook.com/thesignaturetour"><img src="/iceholidays-assets/images/social/ico_fb.png"/></a>
                  <a target="_blank" href="https://wa.me/60128688148"><img src="/iceholidays-assets/images/social/ico_whatsapp.png"/></a>
                  <a target="_blank" href="https://www.instagram.com/thesignaturetours"><img src="/iceholidays-assets/images/social/ico_ig.png"/></a>
                </Flex>
              </Flex>
            </Space>
          </Col>
        </Row>
        <div id="copyright">
          <span>Copyright © 2024 Golden Destinations</span>
        </div>
      </div>
    ) 
  }
}